class ThreeLevelAccordion {
  constructor() {
    this.accordionSections = document.querySelectorAll('.accordion__section');
    this.isScrolling = false;
    this.init();
  }

  init() {
    // Set up event listeners
    this.setupSectionClickListeners();
    this.setupSubsectionClickListeners();
    this.setupKeyboardNavigation();

    // Initialize first section as active
    // this.initializeFirstSection();
  }

  setupSectionClickListeners() {
    this.accordionSections.forEach(section => {
      const button = section.querySelector('.accordion__section-button');

      button.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleSectionClick(section, button);
      });
    });
  }

  setupSubsectionClickListeners() {
    this.accordionSections.forEach(section => {
      const subsectionButtons = section.querySelectorAll('.accordion__subsection-button');
      let trigger = 'click';
      if (undefined !== section.attributes['data-trigger']) {
        trigger = section.attributes['data-trigger'].value;
      }
      subsectionButtons.forEach(button => {
        console.log(trigger);
        button.addEventListener(trigger, (e) => {
          e.preventDefault();
          this.handleSubsectionClick(section, button);
        });
      });
    });
  }

  handleSectionClick(targetSection, button) {
    const isCurrentlyActive = targetSection.classList.contains('accordion__section--active');

    // Close all sections first
    this.closeAllSections();

    // Open target section if it wasn't active
    if (!isCurrentlyActive) {
      this.openSection(targetSection, false); // Pass false to indicate user interaction
    } else {
      // If already active, just scroll to it
      this.scrollSectionToTop(targetSection);
    }

    // Maintain focus on the clicked button
    button.focus();

    // Announce state change for screen readers
    const sectionTitle = button.querySelector('.accordion__section-title').textContent;
    const state = isCurrentlyActive ? 'closed' : 'opened';
    this.announceStateChange(`${sectionTitle} section ${state}`);
  }

  handleSubsectionClick(section, button) {
    const targetId = button.dataset.target;

    // Update navigation state
    this.updateSubsectionNavigation(section, button);

    // Update content display
    this.updateSubsectionContent(section, targetId);

    // Recalculate section content height after subsection change
    this.recalculateSectionHeight(section);

    this.scrollSectionToTop(section);

    // Maintain focus on the clicked button
    button.focus();

    // Announce state change for screen readers
    const subsectionTitle = button.querySelector('.accordion__nav-text').textContent;
    this.announceStateChange(`${subsectionTitle} selected`);
  }

  closeAllSections() {
    this.accordionSections.forEach(section => {
      this.closeSection(section);
    });
  }

  openSection(section, isInitialization = false) {
    section.classList.add('accordion__section--active');

    const button = section.querySelector('.accordion__section-button');
    const content = section.querySelector('.accordion__section-content');
    const toggleIcon = section.querySelector('.accordion__toggle-icon');

    // Update ARIA attributes
    button.setAttribute('aria-expanded', 'true');
    button.setAttribute('aria-selected', 'true');
    content.setAttribute('aria-hidden', 'false');

    // Update toggle icon
    toggleIcon.textContent = '−';

    // Select first subsection by default
    this.selectFirstSubsection(section);

    // Animate content with proper height calculation after subsection is selected
    setTimeout(() => {
      this.recalculateSectionHeight(section);

      // Only scroll if this is NOT initialization
      if (!isInitialization) {
        setTimeout(() => {
          this.scrollSectionToTop(section);
        }, 100);
      }
    }, 10);
  }

  closeSection(section) {
    section.classList.remove('accordion__section--active');

    const button = section.querySelector('.accordion__section-button');
    const content = section.querySelector('.accordion__section-content');
    const toggleIcon = section.querySelector('.accordion__toggle-icon');

    // Update ARIA attributes
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-selected', 'false');
    content.setAttribute('aria-hidden', 'true');

    // Update toggle icon
    toggleIcon.textContent = '+';

    // Animate content close
    content.style.maxHeight = '0';
  }

  updateSubsectionNavigation(section, activeButton) {
    // Remove active state from all nav items in this section
    const navItems = section.querySelectorAll('.accordion__subsection-nav-item');
    const navButtons = section.querySelectorAll('.accordion__subsection-button');

    navItems.forEach(item => {
      item.classList.remove('accordion__subsection-nav-item--active');
    });

    navButtons.forEach(button => {
      button.setAttribute('aria-selected', 'false');
    });

    // Add active state to clicked nav item
    const activeNavItem = activeButton.closest('.accordion__subsection-nav-item');
    activeNavItem.classList.add('accordion__subsection-nav-item--active');
    activeButton.setAttribute('aria-selected', 'true');
  }

  updateSubsectionContent(section, targetId) {
    // Hide all subsection items in this section
    const subsectionItems = section.querySelectorAll('.accordion__subsection-item');
    subsectionItems.forEach(item => {
      item.classList.remove('accordion__subsection-item--active');
      item.setAttribute('aria-hidden', 'true');
    });

    // Show target subsection item
    const targetSubsection = section.querySelector(`[data-subsection="${targetId}"]`);
    if (targetSubsection) {
      targetSubsection.classList.add('accordion__subsection-item--active');
      targetSubsection.setAttribute('aria-hidden', 'false');
    }
  }

  recalculateSectionHeight(section) {
    // Only proceed if this section is active
    if (!section.classList.contains('accordion__section--active')) {
      return;
    }

    const content = section.querySelector('.accordion__section-content');

    // First set height to auto temporarily to get the true scrollHeight
    const currentMaxHeight = content.style.maxHeight;
    content.style.maxHeight = 'none';

    // Force a reflow to ensure the DOM updates
    void content.offsetHeight;

    // Get the actual height and restore the transition
    const newHeight = content.scrollHeight;
    content.style.maxHeight = currentMaxHeight;

    // Force another reflow before setting the new height
    void content.offsetHeight;

    // Set the new max height
    requestAnimationFrame(() => {
      content.style.maxHeight = `${newHeight}px`;
    });
  }

  scrollSectionToTop(section) {
    // Prevent multiple scroll operations
    if (this.isScrolling) return;
    this.isScrolling = true;

    // We need to delay this calculation until after the section has fully expanded
    // to get an accurate scroll position
    setTimeout(() => {
      // Get the section's button element which is what we want at the top
      const button = section.querySelector('.accordion__section-button');
      if (!button) {
        this.isScrolling = false;
        return;
      }

      // Calculate position of the button (not the entire section)
      const buttonRect = button.getBoundingClientRect();
      const buttonTop = window.scrollY + buttonRect.top;

      // Calculate any fixed header height that might exist
      const header = document.querySelector('.c-header__inner');
      const headerHeight = header ? header.offsetHeight : 0;

      // Calculate the final scroll position (account for header if fixed)
      const scrollToPosition = buttonTop - headerHeight;

      // Smooth scroll to the position
      window.scrollTo({
        top: scrollToPosition,
        behavior: 'smooth'
      });

      // Reset scrolling flag after animation completes
      setTimeout(() => {
        this.isScrolling = false;
      }, 500);
    }, 150); // Longer delay to ensure height recalculation has completed
  }

  selectFirstSubsection(section) {
    const firstButton = section.querySelector('.accordion__subsection-button');
    if (firstButton) {
      const targetId = firstButton.dataset.target;
      this.updateSubsectionNavigation(section, firstButton);
      this.updateSubsectionContent(section, targetId);
    }
  }

  setupKeyboardNavigation() {
    // Section navigation with arrow keys
    this.accordionSections.forEach((section, index) => {
      const button = section.querySelector('.accordion__section-button');

      button.addEventListener('keydown', (e) => {
        switch(e.key) {
          case 'ArrowDown':
            e.preventDefault();
            this.focusNextSection(index);
            break;
          case 'ArrowUp':
            e.preventDefault();
            this.focusPreviousSection(index);
            break;
          case 'Home':
            e.preventDefault();
            this.focusFirstSection();
            break;
          case 'End':
            e.preventDefault();
            this.focusLastSection();
            break;
        }
      });
    });

    // Subsection navigation with arrow keys
    this.accordionSections.forEach(section => {
      const navButtons = section.querySelectorAll('.accordion__subsection-button');

      navButtons.forEach((button, index) => {
        button.addEventListener('keydown', (e) => {
          switch(e.key) {
            case 'ArrowDown':
              e.preventDefault();
              this.focusNextSubsection(section, index);
              break;
            case 'ArrowUp':
              e.preventDefault();
              this.focusPreviousSubsection(section, index);
              break;
            case 'Home':
              e.preventDefault();
              this.focusFirstSubsection(section);
              break;
            case 'End':
              e.preventDefault();
              this.focusLastSubsection(section);
              break;
          }
        });
      });
    });
  }

  // Keyboard navigation helper methods
  focusNextSection(currentIndex) {
    const nextIndex = (currentIndex + 1) % this.accordionSections.length;
    const nextButton = this.accordionSections[nextIndex].querySelector('.accordion__section-button');
    nextButton.focus();
  }

  focusPreviousSection(currentIndex) {
    const prevIndex = currentIndex === 0 ? this.accordionSections.length - 1 : currentIndex - 1;
    const prevButton = this.accordionSections[prevIndex].querySelector('.accordion__section-button');
    prevButton.focus();
  }

  focusFirstSection() {
    const firstButton = this.accordionSections[0].querySelector('.accordion__section-button');
    firstButton.focus();
  }

  focusLastSection() {
    const lastButton = this.accordionSections[this.accordionSections.length - 1].querySelector('.accordion__section-button');
    lastButton.focus();
  }

  focusNextSubsection(section, currentIndex) {
    const buttons = section.querySelectorAll('.accordion__subsection-button');
    const nextIndex = (currentIndex + 1) % buttons.length;
    buttons[nextIndex].focus();
  }

  focusPreviousSubsection(section, currentIndex) {
    const buttons = section.querySelectorAll('.accordion__subsection-button');
    const prevIndex = currentIndex === 0 ? buttons.length - 1 : currentIndex - 1;
    buttons[prevIndex].focus();
  }

  focusFirstSubsection(section) {
    const firstButton = section.querySelector('.accordion__subsection-button');
    if (firstButton) {
      firstButton.focus();
    }
  }

  focusLastSubsection(section) {
    const buttons = section.querySelectorAll('.accordion__subsection-button');
    const lastButton = buttons[buttons.length - 1];
    if (lastButton) {
      lastButton.focus();
    }
  }

  initializeFirstSection() {
    const firstSection = this.accordionSections[0];
    if (firstSection) {
      this.openSection(firstSection, true); // Pass true to indicate initialization
    }
  }

  // Screen reader announcements
  announceStateChange(message) {
    // Create or update live region for screen readers
    let liveRegion = document.getElementById('accordion-live-region');
    if (!liveRegion) {
      liveRegion = document.createElement('div');
      liveRegion.id = 'accordion-live-region';
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.setAttribute('aria-atomic', 'true');
      liveRegion.style.position = 'absolute';
      liveRegion.style.left = '-10000px';
      liveRegion.style.width = '1px';
      liveRegion.style.height = '1px';
      liveRegion.style.overflow = 'hidden';
      document.body.appendChild(liveRegion);
    }

    liveRegion.textContent = message;
  }
}

// Initialize accordion when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  let accordion = document.querySelector(".js-accordion");

  if (!accordion) {
    return; // Stop execution on pages without the accordion.
  }

  new ThreeLevelAccordion();

  // Handle responsive behavior
  // window.addEventListener('resize', () => {
  //   // Use a debounced approach to avoid excessive calculations
  //   clearTimeout(window.accordionResizeTimer);
  //   window.accordionResizeTimer = setTimeout(() => {
  //     // Recalculate max-height for open sections on resize
  //     const accordion = new ThreeLevelAccordion();
  //     const activeSections = document.querySelectorAll('.accordion__section--active');
  //    if(!activeSections.length) return;
  //     activeSections.forEach(section => {
  //       accordion.recalculateSectionHeight(section);
  //     });
  //   }, 100);
  // });
});
